import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/M5qVbQBUHYDZcDKF8"
            >
              <CFImage src={mobileMap} w="100%" alt="Jordan Sushi Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/M5qVbQBUHYDZcDKF8"
            >
              <CFImage src={locationMap} w="100%" alt="Jordan Sushi Map" />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
